var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#parking_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.125,
    d: "M12 6.75a5.25 5.25 0 1 0-10.5 0c0 1.81 2.045 4.428 3.583 6.141"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "M6 7.495h1.44a1.26 1.26 0 1 0 0-2.52H6V9.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.125,
    d: "M9.845 11.58h5.248a1.5 1.5 0 0 1 1.5 1.517v1.873h-8.25v-1.873a1.5 1.5 0 0 1 1.502-1.517Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.125,
    d: "M14.155 8.953h-3.37a.75.75 0 0 0-.72.546l-.596 2.082h6.002L14.874 9.5a.75.75 0 0 0-.719-.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.094 13.267a.562.562 0 1 0 1.123 0 .562.562 0 0 0-1.123 0M14.72 13.267a.562.562 0 1 0 1.123 0 .562.562 0 0 0-1.123 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.125,
    d: "M16.595 10.83h-1.34M9.683 10.83h-1.34M10.125 14.955v1.5M15 14.955v1.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "parking_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgParking;